var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen bg-contain bg-center overflow-y-auto",style:({ backgroundImage: `url(${_vm.bgImage})` }),attrs:{"id":"app"}},[_c('div',{staticClass:"container mx-auto pt-1 w-full max-width=100%"},[_c('router-view')],1),_c('v-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }